export const textMessage = {
	message: '',
	sender: '',
};
